import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    username: '',
    token: '',
    userInfo: {}
  },
  mutations: {
    SET_LOGIN_STATUS(state, status) {
      state.isLogin = status
    },
    SET_USERNAME(state, username) {
      state.username = username
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    LOGOUT(state) {
      state.isLogin = false
      state.username = ''
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('username')
    }
  },
  actions: {
    login({ commit }, { username, token, userInfo }) {
      commit('SET_LOGIN_STATUS', true)
      commit('SET_USERNAME', username)
      commit('SET_TOKEN', token)
      if (userInfo) {
        commit('SET_USER_INFO', userInfo)
        localStorage.setItem('user', JSON.stringify(userInfo))
      }
      localStorage.setItem('token', token)
      localStorage.setItem('username', username)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    getUserInfo({ commit }) {
      // 从localStorage获取完整用户信息
      const userStr = localStorage.getItem('user')
      if (userStr) {
        try {
          const userInfo = JSON.parse(userStr)
          commit('SET_USERNAME', userInfo.username || userInfo.name)
          commit('SET_USER_INFO', userInfo)
          commit('SET_LOGIN_STATUS', true)
        } catch (e) {
          console.error('Failed to parse user info from localStorage:', e)
        }
      }
    }
  },
  getters: {
    isLogin: state => state.isLogin,
    username: state => state.username,
    userInfo: state => state.userInfo
  }
})